type HapticPattern =
  | "light"
  | "medium"
  | "heavy"
  | "success"
  | "warning"
  | "error";

const HAPTIC_PATTERNS: Record<HapticPattern, number | number[]> = {
  // single vibrations (duration in ms)
  light: 10,
  medium: 20,
  heavy: 50,

  // pattern vibrations [vibrate, pause, vibrate, ...]
  success: [10, 50, 10], // Double tap
  warning: [30, 100, 30], // Double medium
  error: [50, 100, 50, 100, 50], // Triple strong
};

export const triggerHaptics = (pattern: HapticPattern = "light"): void => {
  // Check if vibration API is available
  if (!navigator.vibrate) {
    return;
  }

  const vibrationPattern = HAPTIC_PATTERNS[pattern];
  navigator.vibrate(vibrationPattern);
};

export default triggerHaptics;
